import { setSew } from '../lib/sewStore';

const n1 = (v, d = 1) => (v == null || !Number.isFinite(+v) ? '–' : (+v).toFixed(d).replace('.', ','));

// comparison of several river rises; the chosen row is shown on the map
export function RiverScen({ t, fl }) {
  if (!fl?.scen || fl.scen.length < 2) return null;
  const pick = (k) => setSew({ flood: { ...fl, sel: k, river: fl.scen[k].river, back: fl.scen[k].back }, on: true });
  return (
    <div className="riv-scen" data-testid="flood-scen">
      <b>{t.flScenT}</b>
      <table>
        <thead><tr><th>{t.flScenRise}</th><th>{t.flScenArea}</th><th>&gt; 10 cm</th><th>{t.flScenMax}</th><th>{t.flScenDry}</th><th>{t.flScenBack}</th></tr></thead>
        <tbody>
          {fl.scen.map((x, k) => (
            <tr key={x.river.rise} className={k === fl.sel ? 'on' : ''} data-testid={`flood-scen-row-${k}`} onClick={() => pick(k)}>
              <td><button type="button" className={`chip${k === fl.sel ? ' on' : ''}`} data-testid={`flood-scen-pick-${k}`}>+{n1(x.river.rise, 2)} m</button></td>
              <td>{n1(x.river.area / 1e4, 2)} ha</td><td>{n1(x.river.deep / 1e4, 2)} ha</td><td>{n1(x.river.maxD * 100, 0)} cm</td><td>{n1(x.river.dry / 1e4, 2)} ha</td><td>{x.back.length}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <small className="muted">{t.flScenHint}</small>
    </div>
  );
}
